<template>
  <div v-if="data" class="report-view">
    <InterlayerPage
      :disable-count="pageCount"
      :site="site.name"
      section="transit"
      :baseline="site.name"
      :filters="filters"
      class="page"
      :title="$t('sections.transit')"
      :transports="[transportMode]"
      :comment="comment"
      :study-collaborators-count="data.collaboratorsCount"
      :transport-collaborators-count="data.filteredCollaboratorsCount"
    />
    <AnalysisSection v-for="(enumeration, idx) in enumerable()" :key="idx" :page-count="pageCount + idx + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.transit') }}</h2>
        <h5>
          {{ $t('report.transitCollaboratorsByTransitTime') }}
          <span v-if="enumerable().length > 1">{{ idx + 1 }}/{{ enumerable().length }}</span>
        </h5>
      </template>
      <template #body>
        <CollaboratorsByTransitTime :data="data" :range="enumeration" :forcedTransport="data.transportMode.key" />
      </template>
    </AnalysisSection>

    <AnalysisSection :page-count="pageCount + enumerable().length + 1" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.transit') }}</h2>
        <h5>{{ $t('report.transitCollaboratorsByTransitTimeChart') }}</h5>
      </template>
      <template #body>
        <CollaboratorsByTransitTimeChart :data="data" :advencedMode="collaboratorsByTimeRangesMode" :sensitiveCaseDuration="study.sensitive_case_duration" />
      </template>
    </AnalysisSection>

    <AnalysisSection :page-count="pageCount + enumerable().length + 2" :filters="filters">
      <template #banner>
        <Banner :data="data" :name="name" :site="site" />
      </template>
      <template #header>
        <h2>{{ $t('sections.transit') }}</h2>
        <h5>{{ $t('report.transitCollaboratorsByTransitTimeChart') }}</h5>
      </template>
      <template #body>
        <CollaboratorsByTransitTimeTable
          :style="{ 'margin-top': collaboratorsByTimeRangesMode ? '64px' : '24px' }"
          :data="data"
          :advencedMode="collaboratorsByTimeRangesMode"
        />
      </template>
    </AnalysisSection>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AnalysisMixin from '@/components/Export/Analysis/Mixin';
import CollaboratorsByTransitTime from '@/components/Analysis/Transit/CollaboratorsByTransitTime';
import CollaboratorsByTransitTimeChart from '@/components/Analysis/Transit/CollaboratorsByTransitTimeChart';
import CollaboratorsByTransitTimeTable from '@/components/Analysis/Transit/CollaboratorsByTransitTimeTable';

export default {
  components: {
    CollaboratorsByTransitTime,
    CollaboratorsByTransitTimeChart,
    CollaboratorsByTransitTimeTable,
  },

  mixins: [AnalysisMixin],

  computed: {
    ...mapGetters(['currentExportLayout']),

    collaboratorsByTimeRangesMode() {
      return this.currentExportLayout?.collaborators_by_time_ranges_mode;
    },
  },
};
</script>
